var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-3 form-group" },
      [
        _vm.divisionList
          ? _c("division-dropdown", {
              attrs: {
                "division-list": _vm.divisionList,
                value: _vm.divisionId
              },
              on: {
                input: function($event) {
                  return _vm.selectDivisionId($event)
                }
              }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-12 form-group" }, [
      _c(
        "div",
        { staticClass: "box" },
        [
          _vm.hasActive
            ? [
                _c("div", { staticClass: "box-header" }, [
                  _c("h3", { staticClass: "box-title" }, [
                    _vm._v(
                      _vm._s(_vm.resource("DmVisualizer_Overview_BoxTitle"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.titleBodyText) }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "box-body" },
                  [
                    _c("scenario-active-overview", {
                      attrs: {
                        "scenario-batches":
                          _vm.activeScenarioBatchList.scenarioBatches
                      },
                      on: {
                        "batches-updated": function($event) {
                          return _vm.replaceActiveScenarioBatches(
                            $event.scenarioId,
                            $event.batches
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.hasHistory
            ? [
                _c("div", { staticClass: "box-header" }, [
                  _c("h3", { staticClass: "box-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.resource("DmVisualizer_Overview_History_BoxTitle")
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "box-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("scenario-historical-overview", {
                          attrs: {
                            "scenario-batches":
                              _vm.historicalScenarioBatchList.scenarioBatches,
                            "from-date":
                              _vm.historicalScenarioBatchList.periodStart,
                            "to-date":
                              _vm.historicalScenarioBatchList.periodEnd,
                            "target-date":
                              _vm.historicalScenarioBatchList.targetDate
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }